import { createContext, useContext } from "react";
import { RouteLine } from "../../../types/RouteLine/RouteLine";

export interface RouteLineContextType {
  setRouteLines: (routeLines: RouteLine[] | null) => void;
  routeLines?: RouteLine[] | null;
  setSelectedRouteLine: (routeLine: RouteLine | null) => void;
  selectedRouteLine?: RouteLine | null;
  showOverlay: boolean;
  setShowOverlay: (show: boolean) => void;
}

const RouteLineContext = createContext<RouteLineContextType | undefined>(
  undefined,
);

const useRouteLineContext = () => {
  const context = useContext(RouteLineContext);

  if (context === undefined) {
    throw new Error("useRouteLineContext was used outside of its Provider");
  }

  return context;
};

export { RouteLineContext, useRouteLineContext };
